<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="ch00_fm01_pre"></a><a id="page_2"></a>“The key to accomplishing your life’s work and living your wildest dreams is a secret hidden in plain view,” Addie Johnson writes. It’s all in a funny-looking, peculiar-sounding word: stick-to-it-iveness. Your grandma was right—anything worth doing is worth doing well, and doing until you do it the way you want to.</p>
<p class="noindent"><em>Stick-to-it-iveness</em> is whimsical, inspirational, and motivational. As the saying goes, when the going gets tough, the tough get going. And this is just the book to get us going. A plethora of quotes, aphorisms, suggestions, and stories make this the perfect read for anyone who’s stuck in the mud or raring to go on a new venture. A phrase a day, and then another, sticking to it is where it’s at.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01_pre.vue?67eb4ea7